import { CONST } from '../utils/constants';
import { isEmptyId } from '../utils/generalUtils';

export interface CourseLocation {
  id: string;
  courseId: string;
  locationId: string;
  companyId: string;
}

function toAPI(data: Partial<CourseLocation>) {
  return {
    Id: !isEmptyId(data?.id) ? data.id : undefined,
    CourseId: data.courseId ?? CONST.emptyGuid,
    LocationId: data.locationId ?? CONST.emptyGuid,
  };
}

function parse(data?: Partial<CourseLocation>): CourseLocation {
  return {
    id: data?.id || '',
    courseId: data?.courseId || CONST.emptyGuid,
    locationId: data?.locationId || CONST.emptyGuid,
    companyId: data?.companyId || '',
  };
}

export default {
  parse,
  toAPI,
};
